import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDollarErrorColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 50 50" {...props}>
      <g clipPath="url(#dollar-error-colored-clip)">
        <circle cx={25.02} cy={25} r={25.02} stroke="#FEDEDE" strokeWidth={9.992} />
        <path
          stroke="#82090F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.3}
          d="M25 19v-1.333M25 31v1.333M27.887 21c-.576-.797-1.653-1.333-2.887-1.333h-.37c-1.637 0-2.963 1.06-2.963 2.37v.102c0 .936.661 1.792 1.708 2.21l3.25 1.301c1.047.419 1.708 1.275 1.708 2.211 0 1.366-1.383 2.472-3.09 2.472H25c-1.234 0-2.311-.536-2.887-1.333M37 25c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12"
        />
      </g>
      <defs>
        <clipPath id="dollar-error-colored-clip">
          <path
            fill="#fff"
            d="M0 25C0 11.193 11.193 0 25 0s25 11.193 25 25-11.193 25-25 25S0 38.807 0 25"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDollarErrorColored);
export default ForwardRef;
